import React from "react";
import styles from "./GameSkeleton.module.scss";

export const GameSkeleton: React.FC = () => {
  return (
    <div className={styles.item}>
      <div className={styles.info}>
        <div className={styles.sectionRow}>
          <div className={styles.titleSkeleton} />
          <div className={styles.pillSkeleton} />
        </div>
        <div className={styles.sectionRow}>
          <div className={styles.textSkeleton} />
          <div className={styles.textSkeleton} />
        </div>
        <div className={styles.commentRow}>
          <div className={styles.commentSkeleton} />
        </div>
        <div className={styles.statusRow}>
          <div className={styles.iconSkeleton} />
          <div className={styles.textSkeleton} />
        </div>
      </div>
      <div className={styles.detailInfo}>
        <div className={styles.detailLabel}>
          <div className={styles.iconSkeleton} />
          <div className={styles.textSkeleton} />
        </div>
      </div>
      <div className={styles.buttonSkeleton} />
    </div>
  );
};
